import useAuth from "@/lib/auth/useAuth";
import { Skeleton } from "@heroui/react";
import {
    createFileRoute,
    useLocation,
    useNavigate,
} from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    useEffect(() => {
        if (!!user && location.pathname === "/") {
            navigate({ to: "/dashboard/home" });
        }
    }, [navigate, user, location.pathname]);
    return (
        <div>
            <Skeleton className="h-screen w-screen" />
        </div>
    );
}
